import { render, staticRenderFns } from "./fuhe_pass.vue?vue&type=template&id=49053032&scoped=true&"
import script from "./fuhe_pass.vue?vue&type=script&lang=js&"
export * from "./fuhe_pass.vue?vue&type=script&lang=js&"
import style0 from "./fuhe_pass.vue?vue&type=style&index=0&id=49053032&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49053032",
  null
  
)

export default component.exports